<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Form - Customer/Sales Order
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
                <b-col lg="8">
                    <b-input-group>
                        <b-input-group-prepend><label>Order Number</label></b-input-group-prepend>
                        <b-form-input v-model="model.nomor" readonly v-b-tooltip.hover title="Auto Numbering"></b-form-input>
                        <b-input-group-prepend><label class="pl-2">&nbsp;&nbsp; Order Date</label></b-input-group-prepend>
                        <b-form-input v-model="model.OrderDate" type="date" :state="!$v.model.OrderDate.$error"></b-form-input>                                        
                    </b-input-group>
                    <b-row no-gutters>
                        <b-col lg="10">
                            <b-input-group >
                                <b-input-group-prepend><label>Customer/Agency</label></b-input-group-prepend>
                                <b-form-input placeholder="Pilih Biro Iklan" v-model="model.custinfo" :state="$v.model.customer_id.$dirty ? !$v.model.customer_id.$error : null" readonly></b-form-input>
                                <b-input-group-append>
                                    <b-btn variant="primary" text="Button" @click="lkuCustomerShow=true" >
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col lg="2">
                            <b-input-group >
                                <b-input-group-prepend><span class="p-2">Currency</span></b-input-group-prepend>
                                <b-form-select class="input-group-text" v-model="model.matauang" :plain="true" :options="currency" :state="!$v.model.matauang.$error"
                                    style="padding-left:1px !important; padding-right:1px !important;"></b-form-select>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="6" v-if="(user.iklan==1)">
                            <b-input-group v-if="(model.billtoadv==1)">
                                <b-input-group-prepend><label>Advertiser</label></b-input-group-prepend>
                                <b-form-input placeholder="Pilih Advertiser" v-model="model.Advertiser" :state="$v.model.adv_id.$dirty ? !$v.model.adv_id.$error : null" readonly></b-form-input>
                                <b-input-group-append>
                                    <b-btn variant="primary" text="Button" @click="lkuAdvertiserShow=true" >
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                            <b-input-group v-else>
                                <b-input-group-prepend><label>Advertiser</label></b-input-group-prepend>
                                <b-form-input placeholder="Input/Pilih Advertiser" v-model="model.Advertiser" :state="$v.model.Advertiser.$dirty ? !$v.model.Advertiser.$error : null" @change="model.adv_id=''"></b-form-input>
                                <b-input-group-append>
                                    <b-btn variant="primary" text="Button" @click="lkuAdvertiserShow=true" >
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Doc. Reference</label></b-input-group-prepend>
                                    <b-form-input v-model="model.ExtrDocNo" placeholder="external doc."></b-form-input>
                                    <b-input-group-append>
                                        <b-btn variant="primary" text="Button" @click="showAttachment=true"  readonly v-b-tooltip.hover title="Attachment">
                                            <i class="fa fa-paperclip"></i>
                                        </b-btn>
                                    </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-row>    
                    <b-input-group>
                        <b-input-group-prepend><label>Brand</label></b-input-group-prepend>
                        <b-form-input placeholder="Masukkan Brand" v-model="model.brand" :state="$v.model.brand.$dirty ? !$v.model.brand.$error : null"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuBrandShow=true" variant="primary"><i class="fa fa-search"></i></b-btn>
                        </b-input-group-append>
                          <b-input-group-prepend><label class="pl-2">&nbsp;&nbsp; Category</label></b-input-group-prepend>
                        <b-form-input placeholder="Masukkan Category" v-model="model.kategori" :state="$v.model.kategori.$dirty ? !$v.model.kategori.$error : null"></b-form-input>
                        <b-input-group-append>
                        <b-btn variant="primary" @click="lkuCategoryShow=true"> <i class="fa fa-search"></i></b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Note/Descript.</label></b-input-group-prepend>
                        <b-form-input v-model="model.uraian" maxlength="250"  :state="!$v.model.uraian.$error"></b-form-input>
                    </b-input-group>

                </b-col>
                <b-col md="4">
                    <b-input-group>
                        <b-input-group-prepend><label>Sales/AE</label></b-input-group-prepend>
                        <b-form-input v-model="model.SalesEx" readonly></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuSalesShow=true" variant="primary"><i class="fa fa-search"></i></b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Campaign</label></b-input-group-prepend>
                        <b-form-input v-model="model.campaign" readonly></b-form-input>
                        <b-input-group-append>
                        <b-btn variant="primary" @click="lkuSalesCamapignShow=true"> <i class="fa fa-search"></i></b-btn>
                        </b-input-group-append>
                    </b-input-group>

                    <v-dim :model="model" :key="updateDimHdr" ></v-dim>
                </b-col>
            </b-row>
            <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblOrderLines"
                    outlined
                    striped hover small
                    style="font-size:smaller;"
                    :items="ordLines.items"
                    :fields="ordLines.fields"
                    :current-page="ordLines.page"
                    :per-page="ordLines.limit"
                    show-empty
                    >
                    <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                    </template>
                    <template v-slot:cell(itemname)="data">
                        {{data.item.itemname}} 
                    </template>
                    <template v-slot:cell(qtyOrder)="data">
                        {{data.item.qtyOrder}} {{data.item.unitsize}}
                    </template>
                    <template v-slot:cell(priceOrder)="data">
                        {{data.item.priceOrder|numFormat}}
                    </template>
                    <template v-slot:cell(grossOrder)="data">
                        {{data.item.grossOrder|numFormat}}
                    </template>
                    <template v-slot:cell(discOrder)="data">
                        {{data.item.discOrder|numFormat}}
                    </template>
                    <template v-slot:cell(nettOrder)="data">
                        {{data.item.nettOrder|numFormat}}
                    </template>
                    <template v-slot:cell(nettSales)="data">
                        {{data.item.nettSales|numFormat}}
                    </template>
                    <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editOrderLines(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        |
                        <a href="javascript:void(0)" class="text-danger" @click="delOrderLines(data.index)">
                            <i class="fa fa-trash"></i>
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                        <b-card class="row-details-form">
                            <b-row  align-h="center">
                                <b-col lg="7" >
                                    <b-row no-gutters>
                                        <b-col md="8">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Sales Item</label></b-input-group-prepend>
                                                <b-form-input readonly v-model="ordLinesObj.itemname" @keyup.13.native="lkuItemShow=true" :state="!$v.ordLinesObj.itemno.$error"></b-form-input>
                                                <b-input-group-append>
                                                <b-btn text="Button" @click="lkuItemShow=true">
                                                    <i class="fa fa-search"></i>
                                                </b-btn>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="4">                            
                                            <b-input-group>
                                                <b-input-group-prepend><span class="p-2">Quantity</span></b-input-group-prepend>
                                                <b-form-input v-model="ordLinesObj.qtyOrder" type="number" v-b-tooltip.hover :title="`Qty: ${ordLinesObj.qtyOrder}`" :state="!$v.ordLinesObj.qtyOrder.$error" min="1"></b-form-input>
                                                <b-form-input v-model="ordLinesObj.unitsize" class="ml-1"></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                    </b-row >
                                    <b-input-group>
                                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                            <b-form-textarea :rows="2" :max-rows="3" v-model="ordLinesObj.description" :state="!$v.ordLinesObj.description.$error" placeholder="Jenis/Posisi/Halaman/Chanel"></b-form-textarea>
                                        <b-form-checkbox id="chkPrint" class="ml-1 mt-2" v-model="ordLinesObj.printhide" value="1" unchecked-value="0" >No Print</b-form-checkbox>
                                    </b-input-group>
                                    <b-row no-gutters>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label >Price (Rate Card)</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.priceOrder" :precision="2" :state="!$v.ordLinesObj.priceOrder.$error"></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><span  class="p-2">Price Disc.</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.priceDiscPc" :precision="2" v-b-tooltip.hover :title="ordLinesObj.priceDiscPc" style="padding-left:1px !important; padding-right:1px !important;"></my-number>
                                                <b-input-group-append><span class="ml-1 pt-2 mr-2"><i class="fa fa-percent"></i></span></b-input-group-append>
                                                <b-input-group-prepend><span class="input-group-text" style="width:55px;">{{model.matauang}}</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.priceNett" :precision="2" style="width:33% !important;" v-b-tooltip.hover title="Saving Value"></my-number>
                                            </b-input-group>                                          
                                        </b-col>
                                    </b-row >   
                                    <b-row>
                                        <b-col md="5">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>PPN(VAT)</label></b-input-group-prepend>
                                                <b-form-checkbox id="chkPPN" class="ml-1 mt-2" v-model="ordLinesObj.kenappn" value=1 unchecked-value=0 @change="calcTaxes()" ></b-form-checkbox>
                                                <b-input-group-prepend ><span  class="pl-2 pt-2 pr-2 text-bold">Tarif</span></b-input-group-prepend>
                                                <b-form-input :disabled="(ordLinesObj.kenappn != 1)" v-model="ordLinesObj.ppn" @change="calcTaxes()" type="number" class="pr-0" v-b-tooltip.hover :title="ordLinesObj.ppn"></b-form-input>
                                                <b-input-group-append > <span class="input-group-text"><i class="fa fa-percent"></i></span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="7">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label style="width:200px !important;">Amt. Due to Customer</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.nilaidue" :precision="2" ></my-number>
                                            </b-input-group>
                                        </b-col>
                                    </b-row >   
                                    <b-row no-gutters>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label >Acc. Booked Sales</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.nettSales" :precision="2" ></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="6">  
                                                <b-form-checkbox id="chkNettSales" class="ml-1 mt-2" v-model="calcSales" value=1 unchecked-value=0>AUTO CALCULATE Acc. Booked Sales</b-form-checkbox>
                                        </b-col>
                                    </b-row >   
                                        <div v-if="(ordLinesObj.required_jadwal==1)" style="float:right;">
                                            <b-input-group >
                                                <b-input-group-append>
                                                    <b-button class="btn btn-success mr-1" @click="saveOrderLines()">Update</b-button>
                                                </b-input-group-append>
                                                <b-input-group-append>
                                                    <b-button class="btn btn-warning mr-2" @click="row.toggleDetails">Cancel</b-button>
                                                </b-input-group-append>
                                                <b-input-group-append><span class="pl-2 pt-2">Schedule</span></b-input-group-append>
                                                <b-input-group-append><span class="input-group-text">{{tgl_akan_muat.length}} Date(s)</span></b-input-group-append>
                                                <!-- <b-input-group-append v-if="tgl_akan_muat.length>0"> -->
                                                <b-input-group-append >
                                                    <b-btn text="Button" class="btn btn-danger ml-1" @click="clearJadwal">
                                                        <i class="fa fa-trash"></i> Clear Schedule
                                                    </b-btn>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>
                                </b-col>
                                <b-col lg="5">
                                    <b-row v-if="(ordLinesObj.required_jadwal==1)" class="justify-content-center mb-0" >
                                        <v-date-picker
                                            v-model="tgl_akan_muat"
                                            :columns="layout.columns"
                                            :rows="layout.rows"
                                            :is-expanded="layout.isExpanded"
                                            @dayclick="selectDate"
                                            mode="multiple"
                                            is-inline class="ml-5"
                                        />
                                    </b-row>
                                    <v-dim v-else :model="ordLinesObj" :key="updateDimDtl" ></v-dim>                                    

                                    <b-row class="justify-content-center mt-1" v-if="(ordLinesObj.required_jadwal==0)">
                                        <div style="width:400px;">
                                            <b-input-group >
                                                <!-- <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                                <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox> -->
                                                <b-input-group-append>
                                                    <b-button class="btn btn-success mr-1" @click="saveOrderLines()">Update</b-button>
                                                </b-input-group-append>
                                                <b-input-group-append>
                                                    <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-card>
                    </template>
                    <template v-slot:cell(empty)="scope">
                        <h4>{{ scope.emptyText }}</h4>
                    </template>
                    <template v-slot:cell(emptyfiltered)="scope">
                        <h4>{{ scope.emptyFilteredText }}</h4>
                    </template>                        
                </b-table>
                 <b-row >
                    <b-col cols="4">
                        <b-row>
                        <b-button size="sm" class="ml-3" @click.stop="addOrderLines" >Add Order item</b-button>                          
                        <div class="ml-2">
                            Showing
                            {{(ordLines.page - 1) * ordLines.limit + 1}}
                            to
                            {{ordLines.page * ordLines.limit}}
                            <strong>
                            of
                            {{ordLines.total}}
                            entries </strong>
                        </div>    
                        </b-row>                    
                    </b-col>
                    <b-col cols="5">          
                    <b-input-group>
                        <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
                        <b-form-input v-model="ordLines.limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${ordLines.limit} records`" style="max-width:80px; !important;"></b-form-input>  
                        <b-pagination
                            :total-rows="ordLines.total"
                            :per-page="ordLines.limit"
                            v-model="ordLines.page"
                        ></b-pagination>
                    </b-input-group>
                    </b-col>
                    <b-col cols="3" >
                    <div class="text-right">
                        <b-input-group>
                            <b-input-group-prepend><span class="pt-2">Accounting Booked Sales</span></b-input-group-prepend>
                            <b-form-input :value="model.ttlSales | numFormat" readonly class="text-right" v-b-tooltip.hover title="Equal to Netto. Check!"></b-form-input>
                        </b-input-group>
                    </div>
                    </b-col>        
                </b-row>
            </b-card>    
            <b-row align-h="between" class="mt-1">
                <b-col lg="8">
                    <b-row no-gutters>
                        <b-col lg="6">
                            <b-input-group >
                            <b-input-group-prepend><label>Bentuk Pembayaran</label></b-input-group-prepend>
                            <b-form-select v-model="model.jenisbayar" :options="paymentForms" :plain="true" class="mr-2" :state="$v.model.jenisbayar.$dirty ? !$v.model.jenisbayar.$error : null"></b-form-select>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><span class="input-group-text">Cara Bayar</span></b-input-group-prepend>
                                <b-form-radio-group inline class="p-1" v-model="model.iscash" >
                                    <b-form-radio value=0>Invoicing</b-form-radio>
                                    <b-form-radio value=1>Tunai (dimuka)</b-form-radio>
                                </b-form-radio-group>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row no-gutters v-if="(model.iscash!=1)">
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Billing Invoice</label></b-input-group-prepend>
                                <b-form-select v-model="model.billing" :options="invoicingTerms" :plain="true" class="mr-2"></b-form-select>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6" >
                            <b-input-group v-if="(user.iklan==1)">
                                <b-input-group-prepend><span class="input-group-text">Tujuan Invoice</span></b-input-group-prepend>
                                <b-form-radio-group inline class="p-1" v-model="model.billtoadv" >
                                    <b-form-radio value=0>Agency</b-form-radio>
                                    <b-form-radio value=1>Advertiser</b-form-radio>
                                </b-form-radio-group>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <!-- <b-input-group v-if="(model.billing=='PER TERMIN')"> -->
                        <!-- <b-input-group-prepend><label>Termin Invoicing</label></b-input-group-prepend>
                        <b-form-input v-model="model.keteranganbayar" placeholder="Keterangan Termin Invoicing" class="mr-5"></b-form-input> -->
                    <!-- </b-input-group> -->
                    <div class="report-wraper" v-if="(model.billing=='PER TERMIN')">
                    <table style="width: 99%;">
                        <thead>
                            <tr>
                                <th width="80">Term</th>
                                <th width="50">Tgl.Penagihan</th>
                                <th style="text-align:right" width="140">Nilai</th>
                                <th>Syarat & Kondisi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in model.terms" :key="item.namaterm">
                                <td>{{item.namaterm}}</td>
                                <td>
                                    <b-form-input v-model="item.tanggal" type="date" ></b-form-input>                                        
                                </td>
                                <td style="padding:0 4px;">
                                    <my-number class="form-control text-right" v-model="item.nilai" :precision="2"></my-number>
                                </td>
                                <td style="padding:0 4px;">                           
                                    <b-form-input  v-model="item.syarat"></b-form-input>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>                  

                  <!-- <div class="bordered"></div> -->
                  <!-- <transition name="slide-fade">
                    <div v-if="((model.billtoadv==1) && (!(model.adv_id)))">
                      <b-input-group>
                        <b-input-group-prepend><label>Nama Advertiser</label></b-input-group-prepend>
                        <b-form-input v-model="model.advnama" placeholder="Nama Advertiser sesuai NPWP" style="width:40% !important;"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">NPWP</span></b-input-group-prepend>
                        <b-form-input v-model="model.advnpwp" placeholder="NPWP"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label>Alamat Advertiser</label></b-input-group-prepend>
                        <b-form-input v-model="model.advaddr1" placeholder="Alamat 1"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label> </label></b-input-group-prepend>
                        <b-form-input v-model="model.advaddr2" placeholder="Alamat 2"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label>Telepon</label></b-input-group-prepend>
                        <b-form-input v-model="model.advtelp" placeholder="No Telepon"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Fax</span></b-input-group-prepend>
                        <b-form-input v-model="model.advcity" placeholder="No. Fax"></b-form-input>
                      </b-input-group>
                    </div>
                  </transition> -->


                    <!-- <b-form-checkbox v-model="model.proforma" inline class="pt-1 ml-2"  value=1 unchecked-value=0>Invoicing FuLL diawal/sebelum iklan dimuat </b-form-checkbox> -->

                        <b-row v-if="(model.matauang !== uanguser)">
                            <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label >Exch. Rate <strong>{{model.matauang}}</strong></label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                </b-input-group-prepend>
                                <my-number  class="form-control text-right" separator="," v-model="model.kursPPN" :state="!$v.model.kursPPN.$error"></my-number>
                            </b-input-group>
                            </b-col>
                            <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: right !important;">Kurs Pajak <strong>{{model.matauang}}</strong></label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{uanguser}}</span></b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="model.kursPPN"  :state="!$v.model.kursPPN.$error"></my-number>
                                </b-input-group>
                            </b-col>
                        </b-row>                      
                </b-col>
                <b-col lg="4">
                    <div class="text-right">
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Gross</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlgross" :precision="2" disabled></my-number>
                        </b-input-group>
                        <!-- <b-input-group >
                            <b-input-group-prepend>
                            <b-form-select style="width:158px;"  v-model="model.calcDisc" :plain="true" :options="calcuationDisc" ></b-form-select>
                            </b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttldiskon" :precision="2" :readonly="(model.calcDisc===1)"></my-number>
                        </b-input-group> -->
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Discount</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttldiskon" :precision="2" ></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Netto</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" readonly v-b-tooltip.hover title="Equal to Accounting Booked sales"></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend>
                            <b-form-select style="width:158px;"  v-model="model.calcVAT" :plain="true" :options="calcuationVAT" ></b-form-select>
                            </b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlvat" :precision="2" :readonly="(model.calcVAT===1)"></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Total Amount Due</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlamtdue" :precision="2" disabled></my-number>
                        </b-input-group>
                    </div>
                </b-col>
            </b-row>

            <b-row class="justify-content-center mb-2">
                <div style="width:450px;">
                    <b-input-group >
                        <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                        <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                        <b-input-group-append>
                            <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                        </b-input-group-append>
                        <b-input-group-append>
                            <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </b-row>

        </b-card>
        <b-modal v-model="lkuSalesShow" size="lg" :hide-footer="true" title="List of Sales Ex." :centered="true">
        <lku-salesae @click="onSelectsales" crudfilter="iklan=1"></lku-salesae>
        </b-modal>
        <b-modal v-model="lkuSalesCamapignShow" size="lg" :hide-footer="true" title="List of Campaign" :centered="true" >
        <lku-salescampaign @click="onSelectsalescamapign"></lku-salescampaign>
        </b-modal>
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Sales Items"  :centered="true">
            <lku-item @click="onSelectLkuItem" ></lku-item>
        </b-modal>        
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        
        <b-modal v-model="lkuAdvertiserShow" size="lg" :hide-footer="true" title="List of Advertiser" :centered="true">
            <lku-advertiser @click="onSelectLkuAdvertiser"></lku-advertiser>
        </b-modal>        
        <b-modal v-model="lkuBrandShow" size="lg" :hide-footer="true" title="List of Brand - Product" :centered="true">
            <lku-salesadvbrand @click="onSelectLkuBrand" isactive="1"></lku-salesadvbrand>
        </b-modal>        
        <b-modal v-model="lkuCategoryShow" size="lg" :hide-footer="true" title="List of Category - Product" :centered="true">
            <lku-salesadvcategory @click="onSelectLkuCategory" isactive="1"></lku-salesadvcategory>
        </b-modal>   
      <b-modal v-model="showAttachment" header-bg-variant="primary"  title="PO/MO Attachment" size="lg" :centered="true" ok-only>
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <b-row class="mt-1" >
                  <span class="p-2" >Selected file: <strong>{{ file ? file.name : '' }}</strong></span>   
              </b-row>
      </b-modal>

    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required, decimal } from "vuelidate/lib/validators";
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuItem from "../lookup/lkuLookupSales";
import lkuAdvertiser from "../lookup/lkuAdvertiser";
import lkuCustomer from "../lookup/lkuCustomer";
import lkuSalesadvbrand from "../lookup/lkuSalesadvbrand";
import lkuSalesadvcategory from "../lookup/lkuSalesadvcategory";
import lkuSalescampaign from "../lookup/lkuSalesCampaign";
import lkuSalesae from "../lookup/lkuSalesae";
import salesorder from "../../apis/salesorder";
import dimension from "../../apis/dimension";
import item from '../../apis/item';
toastr.init();

export default {   
    components: { myNumber, vDim, lkuItem, lkuAdvertiser,lkuCustomer, lkuSalesadvbrand, lkuSalesadvcategory, lkuSalesae, lkuSalescampaign},
    mixins: [validationMixin],
    validations: {
            model: {
                OrderDate: { required },
                customer_id: { required },
                uraian: { required },
                Advertiser:  {required : (function() {
                    if ((this.user.iklan || 0) == 0) {
                        return true;
                    } else if (!(this.model.Advertiser)){
                        return false;
                    } else return true;
                })},
                adv_id:  {required : (function() {
                    if ((this.model.billtoadv || 0) == 0) {
                        return true;
                    } else if (!(this.model.adv_id)){
                        return false;
                    } else return true;
                })},
                brand: { required },
                kategori: { required },
                jenisbayar: { required },
                matauang: { required },
                ttlamtdue: { required },
                kursPPN: {required : (function() {
                    if ((this.model.ttlvat || 0) == 0) {
                        return true;
                    } else if ((this.model.kursPPN || 0) == 0){
                        return false;
                    } else return true;
                })},
            },
            ordLinesObj: {
                itemno: { required },
                priceOrder: { required },
                description: { required },
                qtyOrder: { required },
            },
    }, 
    data() {
        return {
            saveEnabled:true,
            inputBerlanjut: 1,
            inputLineBerlanjut: 0,
            lkuAdvertiserShow:false,
            lkuBrandShow: false,
            lkuCategoryShow: false,
            lkuItemShow:false,
            lkuSalesCamapignShow :false,
            lkuCustomerShow:false,
            lkuSalesShow:false,
            file:null,
            showAttachment:false,
            updateDimHdr:false,
            updateDimDtl:true,
            tarifPPN: this.$store.state.user.tarifppn || 10,
            uanguser: this.$store.state.user.matauang,
            user: this.$store.state.user,
            model: {
                OrderDate: '',
                customer_id: '',
                Advertiser: '',adv_id:'',
                brand: '',
                kategori: '', uraian:'', 
                matauang: this.$store.state.user.matauang, calcVAT:1, calcDisc:0, 
                nofaktur: '',
                tglfaktur: '', jenisbayar:'',
                ttlamtdue: '', terms:[],ttlSales:0,SalesEx:'', SalesExCode:'', salesae_id:'',
                kursPPN: 1,ttldiskon:0, iscash:0, billing:'DI AWAL', billtoadv:0
            },
            tgl_akan_muat:[],      minDate: new Date(),
            calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
            calcuationDisc : [{ value: 1, text: 'Disc (Auto Calc)' }, { value: 0, text: 'Disc (Manual Calc)' }],
            calcPPh:1,calcSales:0,
            ordLinesObj: {
                itemno:'', 
                iteminfo: '',itemname : '',required_jadwal:0,
                description: '',
                qtyOrder: 0,
                nettOrder: 0,nettSales:0,
                priceOrder:0,ppn:10,
                kenappn:1,printhide:0,discOrder:0,
                priceDiscPc:0,priceDisc:0,priceNett:0
            },
            ordLines: {
                items: [],
                selected:{},
                fields: [
                    {key: 'index', label: 'No.' ,thStyle: "width:40px"},                    
                    {
                        key: "saleCrCode",
                        label: "Item Code",
                        thStyle: "width:100px",
                    },
                    {
                        key: "itemname",
                        label: "Item Name",
                    },
                    {
                        key: "description",
                        label: "Description",
                    },
                    {
                        key: "qtyOrder",
                        label: "Quantity",
                        thClass: "text-center",
                        tdClass: "text-center"
                    },
                    {
                        key: "priceOrder", 
                        label: "Price Order",
                        thStyle: "width:100px",
                        thClass: "text-right",
                        tdClass: "text-right"
                    },
                    {
                        key: "grossOrder", 
                        label: "Value Order",
                        thStyle: "width:110px",
                        thClass: "text-right",
                        tdClass: "text-right"
                    },
                    {
                        key: "discOrder", 
                        label: "Saving Value",
                        thStyle: "width:100px",
                        thClass: "text-right",
                        tdClass: "text-right"
                    },
                    {
                        key: "nettOrder", 
                        label: "Due/Nett",
                        thStyle: "width:110px",
                        thClass: "text-right",
                        tdClass: "text-right"
                    },
                    {
                        key: "action",
                        label: "Action",
                        thStyle: "width:40px",
                        thClass: "text-center",
                    },
                    {
                        key: "nettSales", 
                        label: "Acc. Booked Sales",
                        variant: "secondary",
                        thStyle: "width:110px",
                        thClass: "text-right",
                        tdClass: "text-right"
                    },
                ],
                page: 1,
                limit: 5,
                total: 0,
            },
            byae:0,
            currency:[{value:'IDR',text:'IDR'}],
            paymentForms:[{value:'STANDARD', text: 'Standard Cash/Bank'}],
            invoicingTerms:[
                {value:'DI AWAL', text: 'DI AWAL'},
                {value:'PER TERMIN', text: 'PER TERMIN'},
                 {value:'PER TAYANG', text: 'PER TAYANG'},
                 {value:'PER BULAN', text: 'PER BULAN'},
                 {value:'DI AKHIR', text: 'DI AKHIR'}
            ]
        };
    },
    computed: {
        dimension(){
            return this.$store.state.dimension;
        },
        invalidOrderLines() {
            this.$v.ordLinesObj.$touch();
            return this.$v.ordLinesObj.$invalid;
        },
        invalidModel() {
            this.$v.model.$touch();
            return this.$v.model.$invalid;
        },
        maxOrderDate(){
            return moment(new Date()).format('YYYY-MM-DD');
        },
        layout() {
        return this.$screens(
            {
            // Default layout for mobile
            default: {
                columns: 1,
                rows: 1,
                isExpanded: true,
            },
            // Override for large screens
            md: {
                columns: 2,
                rows: 1,
                isExpanded: false,
            },
            lg: {
                columns: 2,
                rows: 1,
                isExpanded: false,
            },
            },
        );
        },

    },
    created: async function(){
        const routeAsal = localStorage.getItem('SoMenu');
        if (routeAsal ==  "sales.customerorderbyae") {
            this.byae=1;
        }
            for (let index = 0; index < 5; index++) {
                // this.model.terms.push({ namaterm: 'Term#' + (index+1), persentase: parseFloat(terms[index]), nilai: (parseFloat(terms[index])/100) * parseFloat(this.model.ttlamtdue) });
                this.model.terms.push({ namaterm: 'Term#' + (index+1), tanggal:null, tglterm:'', nilai:0});
            }

        if (this.$route.params.salesHdrKey)  {
            toastr.info('Loading Request Detail, please wait');
            this.inputBerlanjut=0;
            try {
            const [c,f,data] = await Promise.all([salesorder.currency(),salesorder.paymentform(),salesorder.detail(this.$route.params)]) ;
            this.currency = c;
            this.paymentForms = f;
            
            const row = data[0];
            this.dimension.forEach(dim => {
                if (row[`${dim.value}Txt`]) {
                row[`${dim.value}Info`] = row[`${dim.value}Txt`];
                }
            });
            row.OrderDate = row.OrderDate ? moment(row.OrderDate).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            
            if (this.model.isreject==1 || this.model.isreviewed==1) {
                this.saveEnabled=true;    
            } else if (this.model.send2wf==1) {
                this.saveEnabled=false;
            }
            
            if (this.model.invoiced==1) {
                this.saveEnabled=false;
            } else if ((this.model.status=='100') || (this.model.status=='110')) {
                this.saveEnabled=false;
            } else if (this.model.status=='111') {
                this.saveEnabled=false;
            }

            this.ordLines.items = data[1]
            this.ordLines.total=this.ordLines.items.length;
            this.calcTotalDtlOrder();
            // this.OrderDateBerubah();
            this.updateDimHdr = !this.updateDimHdr;

            const terms= data[2];
            if (this.model.billing=='PER TERMIN'){
                for (let index = 0; index < terms.length; index++) {
                    const t = terms[index];
                      const ada= this.model.terms.find(tr => tr.namaterm==t.namaterm);
                      if (ada){
                         ada.tanggal= moment(t.tglterm).format('YYYY-MM-DD');
                         ada.nilai= t.nilai;
                         ada.syarat= t.syarat;
                         ada.persentase= t.persentase;
                         ada.sotermkey= t.sotermkey;
                         ada.salesHdrKey= t.persentase;

                      }  
                }
            }

            this.$forceUpdate();                
            toastr.clear;
            } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
            }
        } else {
            this.model.OrderDate = moment().format('YYYY-MM-DD');
            const [c,f] = await Promise.all([salesorder.currency(),salesorder.paymentform()]) ;
            this.currency = c;
            this.paymentForms = f;
        } 

  

        this.$watch('ordLinesObj.qtyOrder', function(newVal) {
            if (newVal==this.ordLinesObj.qtyOrder) {
                setTimeout(() => {
                    this.calcAmount();                    
                }, 100);
            }
        });            
        this.$watch('ordLinesObj.priceOrder', function(newVal) {
            if (newVal==this.ordLinesObj.priceOrder) {
                if (this.ordLinesObj.priceDiscPc) {
                    this.ordLinesObj.priceDisc = parseFloat((this.ordLinesObj.priceOrder || 0)) * parseFloat(this.ordLinesObj.priceDiscPc) / 100;        
                    this.ordLinesObj.priceNett = parseFloat(newVal) * (100-parseFloat(this.ordLinesObj.priceDiscPc ||0 )) / 100;        
                }
                setTimeout(() => {
                    this.calcAmount();                    
                }, 100);
            }
        });            
        this.$watch('ordLinesObj.priceDiscPc', function(newVal) {
            if (newVal==this.ordLinesObj.priceDiscPc) {
                this.ordLinesObj.priceDisc = parseFloat((this.ordLinesObj.priceOrder || 0)) * parseFloat(newVal) / 100;        
                this.ordLinesObj.priceNett = parseFloat((this.ordLinesObj.priceOrder || 0)) * (100-parseFloat(newVal ||0 )) / 100;   
                setTimeout(() => {
                    this.calcAmount();                    
                }, 100);
            }     
        });            
        this.$watch('ordLinesObj.priceDisc', function(newVal) {
            if (newVal==this.ordLinesObj.priceDisc) {
                this.ordLinesObj.priceNett = parseFloat((this.ordLinesObj.priceOrder || 0)) -parseFloat(newVal ||0 );        
                if (this.ordLinesObj.priceNett>0) {
                    this.ordLinesObj.printhide=0;
                } else {
                    this.ordLinesObj.printhide=1;
                }
                setTimeout(() => {
                    this.calcAmount();                    
                }, 100);
            }
        });            
        this.$watch('model.ttldiskon', function(newVal) {
            this.model.ttlnetto=this.model.ttlgross-this.model.ttldiskon;
            this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
        });            
        this.$watch('model.ttlvat', function(newVal) {
            this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
        });            
        this.$watch('calcSales', function(newVal) {
            if (newVal==1) {
                this.ordLinesObj.nettSales = this.ordLinesObj.nettOrder || this.ordLinesObj.grossOrder;
            }
        });            

    },
    methods: {
        closeOrderLines: function(){
            const opened= this.ordLines.items.find( r=> r._showDetails==true);
            if (opened) opened._showDetails=false;
        },
        addOrderLines : function () {
            this.closeOrderLines();
            const obj={_showDetails:true};
            this.ordLines.selected = obj;
            for (var key in this.ordLinesObj) {
                this.ordLinesObj[key] = '';
            }
            this.tgl_akan_muat=[];
            this.ordLinesObj.unitsize='EACH';
            this.ordLinesObj.qtyOrder = 1;
            this.ordLinesObj.qtyUndefined = 0;
            this.ordLinesObj.nettOrder= 0;
            this.ordLinesObj.kenappn = 0;
            this.ordLinesObj.ppn = this.tarifPPN;
            this.ordLinesObj.priceDiscPc=0;
            this.ordLinesObj.discOrder=0,
            this.ordLinesObj.printhide=0;
            this.updateDimHdr2Dtl(this.ordLinesObj);
            this.ordLines.items.push(obj);
            this.ordLines.total=this.ordLines.items.length;
            setTimeout(() => {
                const bfore = this.ordLines.page;
                const after =Math.ceil((this.ordLines.total)/this.ordLines.limit);
                if (bfore != after){
                    this.ordLines.page =  after;                 
                    toastr.info(`Move to page ${after} of total  ${this.ordLines.total} items`,'Line/Detail PR',10000);
                }
            }, 100);    
        },
        editOrderLines : function (obj,callback) {
            this.closeOrderLines();
            this.ordLines.selected = obj;
            // for (var key in this.ordLinesObj) {
            //     this.ordLinesObj[key] = '';
            // }
            this.dimension.forEach(dim => {
                if (obj[`${dim.value}Txt`]) {
                obj[`${dim.value}Info`] = obj[`${dim.value}Txt`];
                }
            });
            for (var key in obj) {
                this.ordLinesObj[key] = obj[key];
            }
            this.tgl_akan_muat=[];
            // if (obj.jadwal){
            //     this.tgl_akan_muat= JSON.parse(obj.jadwal);
            // }
            const arrJadwal=JSON.parse(obj.jadwal); 
            arrJadwal.forEach((jd,idx)=>{
            this.tgl_akan_muat.push(new Date(jd));
            });            
            this.ordLinesObj.typeseries = `${obj.itemcategory}`;
            this.dimension.forEach((dim) => {
                if (obj[dim.value]) {
                    this.ordLinesObj[dim.value] = obj[dim.value];
                    this.ordLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                    this.ordLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
                }
            });
            callback();
        },
        delOrderLines: function (index) {
            if (index > -1) {
                // this.ordLines.items.splice(index, 1);
                const posisi = (this.ordLines.page-1)*this.ordLines.limit;
                this.ordLines.items.splice(posisi+index, 1);
            }
            this.ordLines.total=this.ordLines.items.length;
            this.calcTotalDtlOrder();
        },
        saveOrderLines: async function (callback) {
            this.calcAmount();
            if (this.invalidOrderLines) {
                    console.log('validation : ', this.$v.ordLinesObj);
                    console.log('model obj : ',this.ordLinesObj);
                    toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            } else {
                    let datadim=this.ordLinesObj;
                    datadim.TableName = 'sales_order_line';
                    try {
                        const dimValResult = await dimension.validate(datadim);
                        if (dimValResult.success) {
                            const arrJadwal= this.tgl_akan_muat.map(jd => moment(jd).format('YYYY-MM-DD'));        
                            this.ordLinesObj.jadwal= JSON.stringify(arrJadwal);
                            for (var key in this.ordLinesObj) {
                                this.ordLines.selected[key] = this.ordLinesObj[key];
                            }
                            if (this.calcSales==1) {
                                this.calcNettSales();
                            } else if ((this.ordLinesObj.grossOrder!=0) && (this.ordLinesObj.nettSales||0)==0) {
                                const pesan=`Acc.Booked Sales tidak diisi atau 0(NOL), Sistem akan menghitung Otomatis (AUTO CALCULATE)?`;
                                this.$bvModal.msgBoxConfirm(pesan, {
                                title: 'Please Confirm',
                                size: 'md',
                                buttonSize: 'sm',
                                okVariant: 'success',
                                okTitle: 'YES',
                                cancelTitle: 'NO',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true
                                })
                                .then(async(value) => {
                                    if (value==true) {
                                        this.calcNettSales();
                                        setTimeout(() => {
                                            this.calcTotalDtlOrder();
                                        }, 300); 

                                    }
                                })
                                .catch(err => {
                                // An error occurred
                                })  
                            }

                            this.dimension.forEach((dim) => {
                                if (datadim[dim.value]) {
                                    this.ordLines.selected[dim.value] = datadim[dim.value];
                                    this.ordLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
                                }
                            });
                            this.updateDimDtl2Hdr(datadim);
                            setTimeout(() => {
                                this.calcTotalDtlOrder();
                            }, 100); 
                            this.ordLines.selected._showDetails=false;
                            if (callback) callback();
                            if (this.inputLineBerlanjut==1) {
                                this.addOrderLines();
                                this.$v.ordLinesObj.$reset();
                            }

                        } else {
                            var msg = dimValResult.message;
                            if (callback) callback(new Error(msg));
                            else {
                                toastr.error(msg, "ERROR MESSAGE",10000);
                            }
                        }
                    } catch (error) {
                        console.log('error : ', error);
                        if (error.message) {
                            toastr.error(error.message,'ERROR MESSAGE',10000);
                        } else {
                            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                        }
                    }
            }
        },
        save: async function () {
            if (!this.saveEnabled) {
                toastr.error('View mode cannot be Saved');
                return;
            }
            this.saveEnabled=false;
            this.calcTotalDtlOrder();
            if (this.invalidModel) {
                const invalidobj={};
                for (var key in this.$v.model) {
                if (this.$v.model[key].$anyError) {
                    if (this.$v.model[key].$anyError==true) invalidobj[key] = this.$v.model[key];
                }
                }        
                console.log('validation model: ', this.model);
                console.log('validation field: ', invalidobj);
                toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
                this.saveEnabled=true;
            // } else if (Math.abs(this.model.ttlSales-this.model.ttlnetto)>0.5) {
            } else if (Math.abs(this.model.ttlSales-this.model.ttlgross)>0.5) {
                toastr.error('Total Accounting Booked Sales & Total Gross is not Balance ', 5000, "ERROR MESSAGE");
                this.saveEnabled=true;
            } else {                
                try {
                    this.model.TableName = 'sales_order';
                    const dimValResult = await dimension.validate(this.model);
                    if (dimValResult.success) {
                        // this.model.DimTableKey = diisi dari PR/SR;
                        this.model.salesHdrKey = this.model.salesHdrKey || '';
                        this.model.nomor = this.model.nomor || '';
                        let lineno=0;
                        let diskonrkp=0;
                        const row = new FormData();
                        if (this.file){
                            row.append('file', this.file);
                            row.append('filename', this.file.name);
                        }
                        for (var key in this.model) {
                            row.append(key, this.model[key]);
                        }
                        row.set('OrderDate', moment(this.model.OrderDate).format('YYYY-MM-DD'));
                        const lines = this.ordLines.items.reduce((newArr, item) => {
                            if (((item.itemno || '') != '') && (item.qtyOrder != 0)) {
                                item.lineno = lineno+1;
                                item.valueIssued = this.ordLinesObj.invUnitCost * this.ordLinesObj.qtyOrder;
                                diskonrkp += item.priceDisc;    
                                newArr.push(item);
                                lineno += 1;
                            }
                            return newArr;
                        }, []);
                        row.set('diskonrkp',diskonrkp);
                        row.append(`lines`,JSON.stringify(lines));
                        if (this.model.billing=='PER TERMIN'){
                            const termin = this.model.terms.reduce((newArr, t) => {
                                if (parseFloat(t.nilai ||0 )>0) {                                    
                                    if (t.tanggal) {
                                        t.tglterm= moment(t.tanggal).format('YYYY-MM-DD');
                                        newArr.push(t);
                                    } else {
                                        toastr.error(`Perkiraan Tgl.Penagihan ${t.namaterm} harus diisi` , "ERROR MESSAGE", 1000);
                                        // return;
                                    }
                                }
                                return newArr;
                            }, []);                            
                            console.log('terms: ', termin);
                            if (termin.length>0) {
                                row.append(`termin`,JSON.stringify(termin));
                            } else {
                                toastr.error('Please fill the INVOICING TERM', "ERROR MESSAGE");
                                this.saveEnabled=true;
                                return;
                            }
                        }
    
                        if (lines.length>0) {
                            const hasil= await salesorder.save(row);
                            toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save Sales Order",10000);

                            if (this.inputBerlanjut==0){
                                this.close();
                            } else {
                                this.saveEnabled=true;            
                                for (var key in this.model) {
                                    this.model[key] = '';
                                }
                                this.model.matauang= this.$store.state.user.matauang;
                                this.model.tglpaym = moment().format('YYYY-MM-DD');
                                this.totalDtlPaym=0;
                                for (var key in this.ordLinesObj) {
                                    this.ordLinesObj[key] = '';
                                }
                                this.ordLines.items = [];
                                this.ordLines.total=0;
                                this.calcTotalDtlOrder();
                                this.$v.model.$reset();
                            }

                        } else {
                            toastr.error('Please fill at least 1(one) Order Detail', 'ERROR MESSAGE');
                            this.saveEnabled=true;
                        }
                    } else {
                        var msg = dimValResult.message || 'Dimension validation error';
                        toastr.error(msg, "ERROR MESSAGE");
                        this.saveEnabled=true;
                    }
                } catch (error) {
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
                    this.saveEnabled=true;            
                }

            }
        },
        onSelectLkuAdvertiser: function (_selected) {
            this.lkuAdvertiserShow=false;
            this.model.Advertiser = _selected.CustName;
            this.model.adv_id = _selected.customer_id;
            this.model.advnama= _selected.npwp_name || _selected.CustName;
            this.model.advnpwp= _selected.npwp;
            this.model.advaddr1= _selected.Addresss1;
            this.model.advaddr2= _selected.Addresss2;
            this.model.advtelp= _selected.PhoneNo;
            this.model.advcity= _selected.City;
        },  
        
        onSelectLkuBrand: function (_selected) {
            this.model.brand = _selected.brandname;
            this.lkuBrandShow=false;
        },  
        onSelectLkuCategory: function (_selected) {
            this.model.kategori = _selected.categoryname;
            this.lkuCategoryShow=false;
        },  
        onSelectLkuCustomer: function (_selected) {
            this.model.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
            this.model.customer_id = _selected.customer_id;
            this.model.Sell2Cust = _selected.CustCode.trim();
            this.lkuCustomerShow=false;
        },  
        onSelectLkuItem(_selected) {
            this.lkuItemShow=false;
            this.ordLinesObj.itemname = _selected.NamaSale;
            this.ordLinesObj.iteminfo =_selected.saleCrCode.trim() + " | " + _selected.NamaSale.trim();
            this.ordLinesObj.saleCrCode = _selected.saleCrCode;
            this.ordLinesObj.itemno = _selected.kode;
            this.ordLinesObj.required_jadwal  = _selected.required_jadwal;
            if (_selected.iklandigital==1) {
                this.ordLinesObj.unitsize='SPOT';
            }
            if (_selected.iklancetak==1) {
                this.ordLinesObj.unitsize='TAYANG';
            }
            this.calcAmount();
        },
        onSelectsales(_selected) {
            this.model.SalesEx = `${_selected.salesae_name} ${" | "+_selected.crewnik} `;
            // this.model.SalesExCode = _selected.crewkey;
            this.model.SalesExCode = _selected.salesae_id;
            this.model.salesae_id = _selected.salesae_id;
            this.lkuSalesShow = false;
        },
        onSelectsalescamapign(_selected) {
            this.model.campaign = `${_selected.uraian}`;
            this.model.CampaignKey = _selected.campaignKey;
            this.lkuSalesCamapignShow = false;
        },

        updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
        },
        updateDimHdr2Dtl: function (dimDtl) {
            var dimHdr = this.model;
            dimDtl = dimDtl || this.ordLinesObj;
            this.dimension.forEach((dim) => {
                if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                    dimDtl[dim.value] = dimHdr[dim.value];
                    dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                    dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
                }
            });
            this.updateDimDtl = !this.updateDimDtl;
        },
        selectDate(val) {
            const date = moment(val.date).format('YYYY-MM-DD');
            const index = this.tgl_akan_muat.findIndex(tgl => moment(tgl).format('YYYY-MM-DD') === date);      
            if (index > -1) {
                this.tgl_akan_muat.splice(index, 1);
            } else {
                this.tgl_akan_muat.push(new Date(date));
            }
        },
        clearJadwal: function(){
            this.tgl_akan_muat=[];
        },
        calcAmount : function() {
            this.ordLinesObj.grossOrder = parseFloat(this.ordLinesObj.priceOrder || 0) * parseFloat(this.ordLinesObj.qtyOrder || 0);
            this.ordLinesObj.discOrder = parseFloat(this.ordLinesObj.priceDisc  || 0) * parseFloat((this.ordLinesObj.qtyOrder || 0));        
            this.ordLinesObj.nettOrder = this.ordLinesObj.grossOrder -this.ordLinesObj.discOrder; 
            if (this.calcSales==1) {
                this.ordLinesObj.nettSales = this.ordLinesObj.nettOrder || this.ordLinesObj.grossOrder;
            }

            this.calcTaxes();
        },
        calcNettSales: function(){
            const sortLines = this.ordLines.items.sort(function(a, b){return b.nettOrder - a.nettOrder});
            const tertinggi = sortLines[0];
            if ((tertinggi.nettOrder || 0)>0) {
                const idxTertinggi = this.ordLines.items.findIndex(l => ((l.nettOrder==tertinggi.nettOrder) && (l.itemno==tertinggi.itemno)));
                this.ordLines.items[idxTertinggi].nettSales = this.ordLines.items[idxTertinggi].nettOrder;
                this.ordLines.items.forEach((l,idx)=>{
                    if (idxTertinggi!=idx){
                        // if ((l.grossOrder!=0) && (l.nettOrder==0)) {
                            l.nettSales = l.grossOrder;
                            this.ordLines.items[idxTertinggi].nettSales-= l.discOrder; 
                        // }
                    } 
                });
            }
        },
        calcTaxes : function() {
            // this.ordLinesObj.nettOrder = parseFloat(this.ordLinesObj.grossOrder || 0) - parseFloat(this.ordLinesObj.priceDisc || 0);
            this.ordLinesObj.dpp = parseFloat(this.ordLinesObj.nettOrder  || 0);
            // if (this.ordLinesObj.kenappn == 1) {
            //     this.model.grossup = 0;
            //     this.ordLinesObj.ppn = this.tarifPPN;
            // } else {
            //     this.ordLinesObj.dpp = 0;
            //     this.ordLinesObj.ppn = 0;
            // }
            this.ordLinesObj.nilaippn = 0;
            if (this.ordLinesObj.kenappn == 1) {
                this.ordLinesObj.nilaippn = (parseFloat(this.ordLinesObj.ppn)/100) * this.ordLinesObj.dpp;;
            }

            this.ordLinesObj.nilaidue = parseFloat(this.ordLinesObj.nettOrder) + this.ordLinesObj.nilaippn;
            this.$forceUpdate();
        },
        calcTotalDtlOrder: function () {
            this.model.calcVAT = this.model.calcVAT || 1;
            this.model.calcDisc = this.model.calcDisc || 0;
            let nilaidpp = 0;
            let ttlvat = 0;
            let ttlgross = 0;
            let ttlSales = 0;
            // let totaldpp = 0;
            this.ordLines.items.forEach( function (trx) {
                if (trx.kenappn==1) {
                    trx.dpp=trx.nettOrder;
                }

                if (trx.itemno) {
                    nilaidpp += (trx.dpp || 0);
                    ttlgross += (trx.nettOrder || 0);
                    // ttldiskon += (trx.discOrder  || 0);
                    ttlvat += (trx.nilaippn || 0);
                    ttlSales += (trx.nettSales || 0);
                }
            });
            this.model.ttlSales = ttlSales;
            this.model.nilaidpp = nilaidpp;
            this.model.ttlgross = ttlgross;
            if (this.model.calcVAT == 1){
                this.model.ttlvat = ttlvat;
            }
            // if (this.model.calcDisc == 1){
            //     this.model.ttldiskon = ttldiskon;
            // }
            this.model.ttlnetto =this.model.ttlgross - parseFloat(this.model.ttldiskon);
            this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
        },
        close(){
           if (this.byae==1) {
             router.push({path: "customer-order-byae/1"});
           } else {
            router.push({name:'sales.customerorder'});
           }           

        }
    }
};
</script>
